import * as React from "react";
import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import Link from "@mui/joy/Link";
import {Link as RouterLink} from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { Typography } from "@mui/joy";

export default function ConsoleHomePage() {
  return (
    <>

      <Box sx={{display: 'flex', alignItems: 'center'}}>
        <Breadcrumbs
          size="sm"
          aria-label="breadcrumbs"
          separator={<ChevronRightRoundedIcon fontSize="small"/>}
          sx={{pl: 0}}
        >
          <Link
            underline="none"
            color="neutral"
            component={RouterLink}
            to="/console"
          >
            <HomeRoundedIcon/>
          </Link>
        </Breadcrumbs>
      </Box>


      <Typography>안녕하세요.</Typography>
      <Typography>좌측 메뉴에서 URL을 확인하시고 예약 메시지에 첨부하세요.</Typography>
      <Typography>응답지 조회 메뉴에서 응답 결과를 확인하세요.</Typography>
    </>
  );
}